import React, { ErrorInfo, ReactNode } from 'react';
import { captureError } from '../../posthog';
import { Error as ErrorComponent } from './Error';
import './style.scss';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

const ErrorBoundaryFallback = () => (
  <div className="Error__boundaryContainer">
    <div className="Error__boundary">
      <ErrorComponent />
    </div>
  </div>
);

export class ErrorBoundary extends React.Component<Props, State> {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    captureError(error, {
      context: 'react error boundary',
      source: 'react_error_boundary',
      metadata: {
        component_stack: errorInfo.componentStack,
      },
    });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorBoundaryFallback />;
    }

    return this.props.children;
  }
}

const ErrorBoundaryHandler = ({ children }: Props) => {
  return <ErrorBoundary>{children}</ErrorBoundary>;
};

export default ErrorBoundaryHandler;
